import filters from './filters.getters';
import tiles from './tiles.getters';

export default {
    ...filters,
    ...tiles,
};
